"use client";

import React from "react";
import { Eye, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 8,
  product_tag: [20]
};
const wp_query = new WP_Query(wp_query_params);
function SweetCollectionGrid() {
  const {
    products,
    loading,
    error,
    refetch,
    hasNext,
    hasPrev,
    nextPage,
    prevPage
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="112503" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-[400px] rounded-xl bg-primary/5 animate-pulse border border-primary/10 backdrop-blur-sm" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-muted-foreground">
        <p className="mb-4 font-serif text-xl">Unable to retrieve the catch of the day.</p>
        <Button variant="outline" onClick={refetch} className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
          Try Again
        </Button>
      </div>;
  }
  if (products.length === 0) {
    return <div className="text-center py-20 border-2 border-dashed border-primary/20 rounded-xl bg-white/40 backdrop-blur-md">
        <p className="text-primary font-serif text-2xl italic">Our fleet is currently preparing the next selection.</p>
        <p className="text-muted-foreground mt-2 max-w-md mx-auto px-4">Check back soon for the finest frozen seafood delivered exclusively to your Florida village doorstep.</p>
      </div>;
  }
  return <div className="space-y-8">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {products.map((product, i) => <div key={product.id} data-index={i} className="group relative flex flex-col bg-card rounded-xl shadow-sm border border-border/50 overflow-hidden transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
            {}
            <div className="relative aspect-square overflow-hidden bg-muted">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-secondary/20 text-primary/40">
                  Village Catch
                </div>}

              {}
              <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-[2px]">
                <Button variant="secondary" size="sm" className="rounded-full shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 bg-white text-primary hover:bg-primary hover:text-white" asChild>
                  <Link to={product.link}>
                    <Eye className="w-4 h-4 mr-2" />
                    View Details
                  </Link>
                </Button>
              </div>
            </div>

            {}
            <div className="p-6 flex flex-col flex-grow bg-white/80">
              <Link to={product.link} className="hover:text-secondary transition-colors">
                <h3 className="font-serif text-primary font-bold text-lg md:text-xl mb-2 line-clamp-2 leading-tight">
                  {product.title}
                </h3>
              </Link>
              <div className="text-primary font-sans font-semibold text-lg mb-6 mt-auto">
                ${product.price?.toFixed(2) || "0.00"}
              </div>

              {}
              <div className="mt-auto">
                <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-accent text-white w-full rounded-lg hover:bg-accent/90 transition-all duration-300 shadow-sm hover:shadow-md font-sans font-medium" text="Add to Catch" showQuantity={false} />
              </div>
            </div>
          </div>)}
      </div>

      {}
      {(hasNext || hasPrev) && <div className="flex items-center justify-center gap-6 pt-10 border-t border-primary/10">
          <Button variant="outline" size="icon" onClick={prevPage} disabled={!hasPrev} className="rounded-full border-primary/20 text-primary hover:bg-primary hover:text-white transition-colors" aria-label="Previous page">
            <ChevronLeft className="w-5 h-5" />
          </Button>
          <div className="flex gap-2">
             <span className="w-2.5 h-2.5 rounded-full bg-primary shadow-sm"></span>
             <span className="w-2.5 h-2.5 rounded-full bg-primary/20"></span>
             <span className="w-2.5 h-2.5 rounded-full bg-primary/20"></span>
          </div>
          <Button variant="outline" size="icon" onClick={nextPage} disabled={!hasNext} className="rounded-full border-primary/20 text-primary hover:bg-primary hover:text-white transition-colors" aria-label="Next page">
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>}
    </div>;
}
export default function SweetDelightsCollection() {
  return <section id="the-village-catch" className="w-full bg-secondary py-24 md:py-32 lg:py-40 text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className="mb-12 md:mb-16 text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary font-serif inline-block relative pb-6 tracking-tighter">
            Today's Village Selection
            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-[3px] bg-accent"></span>
          </h2>
        </div>

        {}
        <EcommerceProductsProvider wp_query={{
        per_page: 8,
        product_tag: [20]
      }} className="village-selection-wrapper">
          <SweetCollectionGrid />
        </EcommerceProductsProvider>
      </div>
    </section>;
}